import { Navigate } from 'react-router';
import { useAuth } from '../../hooks/useAuth';
import { useAuthStore } from '../../stores/authStore';
import type { Role } from '@enerlyze/shared';
import { useEffect } from 'react';

// TODO: REMOVE THIS — dev-only auth bypass for UI preview without backend
const DEV_AUTH_BYPASS = import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH_BYPASS === 'true';

interface ProtectedRouteProps {
  children: React.ReactNode;
  minimumRole?: Role;
}

export function ProtectedRoute({ children, minimumRole }: ProtectedRouteProps) {
  const { isAuthenticated, isAuthorized } = useAuth();
  const setAuth = useAuthStore((s) => s.setAuth);

  // TODO: REMOVE THIS — dev-only auth bypass for UI preview without backend
  useEffect(() => {
    if (DEV_AUTH_BYPASS && !isAuthenticated) {
      setAuth(
        { id: 0, email: 'dev@preview', role: 'master', accountId: 1, isActive: true },
        'dev-bypass-token',
        'dev-bypass-refresh',
      );
    }
  }, [DEV_AUTH_BYPASS, isAuthenticated, setAuth]);

  if (DEV_AUTH_BYPASS) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (minimumRole && !isAuthorized(minimumRole)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-950 text-white">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-2">403</h1>
          <p className="text-gray-400">You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
